import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import * as moment from "moment"
import { xmlFormatter } from "../helpers/xmlFormatter"

export async function GetCompanyList(tallyHost, tallyPort) {

    if(!tallyHost) {
        tallyHost = TallyConfig.host
    }
    if (!tallyPort) {
        tallyPort = TallyConfig.port
    }

    let data = `
        <ENVELOPE>
            <HEADER>
            <VERSION>1</VERSION>
            <TALLYREQUEST>Export</TALLYREQUEST>
            <TYPE>Collection</TYPE>
            <ID>Collection of Ledgers</ID>
            </HEADER>
            <BODY>
            <DESC>
                <STATICVARIABLES>
                <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                </STATICVARIABLES>
                <TDL>
                <TDLMESSAGE>
                    <COLLECTION NAME="Collection of Ledgers" ISMODIFY="No">
                    <TYPE>Company</TYPE>
                    <FETCH>GUID,ALTERID,MASTERID,NAME,STATE,STARTINGFROM,BOOKSFROM,ENDINGAT,LASTVOUCHERDATE,CMPVCHID,ALTVCHID,ALTMSTID,ISAGGREGATE,BASICCOMPANYFORMALNAME,COMPANYCHEQUENAME,COMPANYCONTACTPERSON,COMPANYCONTACTNUMBER,EMAIL,WEBSITE,PHONENUMBER,CMPMOBNO,MOBILENO,ADDRESS,STATENAME,CITYNAME,PLACENAME,_ADDRESS1,_ADDRESS2,_ADDRESS3,_ADDRESS4,_ADDRESS5,_ADDRESS,STATENAME,PINCODE,COUNTRYNAME,VATTINNUMBER,UDF:CORPORATEIDENTITYNO,CORPORATEIDENTITYNO,INTERSTATESTNUMBER,TANUMBER,STREGNUMBER,CMPPFCODE,INCOMETAXNUMBER,GSTREGISTRATIONTYPE,GSTAPPLICABLEDATE,ISGSTCESSON,GSTDETAILS.LIST,DESTINATION</FETCH>
                    <FILTERS>GroupFilter</FILTERS>
                    </COLLECTION>
                    <SYSTEM TYPE="FORMULAE" NAME="GroupFilter">$isaggregate =  "No" </SYSTEM>
                </TDLMESSAGE>
                </TDL>
            </DESC>
            </BODY>
        </ENVELOPE>
    `

    data = xmlFormatter(data)

    console.log(tallyHost, tallyPort)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${tallyHost}:${tallyPort}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            let isCompanyActive = {}
            
            
            jsonData = jsonData?.ENVELOPE?.BODY?.DATA?.COLLECTION?.COMPANY || []
            if (!(jsonData instanceof Array)) {
                jsonData = [jsonData]
            }

            console.log(jsonData)

            jsonData.forEach((company) => {
                isCompanyActive[company?._attributes?.NAME] = {
                    name: company?._attributes?.NAME,
                    address: (company?._ADDRESS1?._text || "") + ", " + (company?._ADDRESS2?._text || "") + ", " + (company?._ADDRESS3?._text || "") + ", " + (company?._ADDRESS4?._text || "") + ", " + (company?._ADDRESS5?._text || ""),
                    state: company?.STATENAME?._text || "",
                    pincode: company?.PINCODE?._text || "",
                    startingFrom: company?.STARTINGFROM?._text,
                }
            })
            window.localStorage.setItem(`tally-company-list`, JSON.stringify(isCompanyActive))

            return isCompanyActive
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}